import { z } from "zod";

import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";

export const contactTypeOptions = [
  { value: "it_support", label: "IT support" },
  { value: "private_banker", label: "Private banker" },
];

export const filterFoBankContactSchema = z.object({
  client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  sub_client_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  company_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  contact_type_equals: z.string().nullable().optional(),
});

export type FilterFoBankContactSchema = z.infer<
  typeof filterFoBankContactSchema
>;

export const fields: Field[] = [
  {
    name: "client_contains",
    label: "Client",
    type: "asyncAutocomplete",
    base_url: "fo-quantilia/fo_bank_contact",
    column_name: "client",
  },
  {
    name: "sub_client_contains",
    label: "Sub-client",
    type: "asyncAutocomplete",
    base_url: "fo-quantilia/fo_bank_contact",
    column_name: "sub_client",
  },
  {
    name: "company_name_contains",
    label: "Banque",
    type: "asyncAutocomplete",
    base_url: "instit-quantilia/companies",
    column_name: "name",
  },
  {
    name: "contact_type_equals",
    label: "Type de contact",
    type: "select",
    useTranslation: false,
    options: contactTypeOptions,
  },
];

export function FilterFoBankContact() {
  return (
    <FilterTable
      client="fo-quantilia"
      schema={filterFoBankContactSchema}
      tableName="fo_bank_contact"
      customBuildPath={() => "fo/fo_bank_contact"}
      fields={fields}
      columns={2}
    />
  );
}
